import { render, staticRenderFns } from "./contracts-item.vue?vue&type=template&id=8ebd4d2c"
import script from "./contracts-item.vue?vue&type=script&lang=js"
export * from "./contracts-item.vue?vue&type=script&lang=js"
import style0 from "./contracts-item.vue?vue&type=style&index=0&id=8ebd4d2c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports